<script>
import ModalCloseButton from '@phoenix/mixins/components/common/ModalCloseButton';
import { PhxIcon } from '@phx-styleguides/jlc';

export default {
  components: { PhxIcon },

  mixins: [ModalCloseButton],

  props: {
    isFullscreenIframe: {
      type: Boolean,
      default: false,
    },
    baseClasses: {
      type: String,
      default: 'modal__close btn--sm ms-auto',
    },
  },

  computed: {
    classes() {
      return [
        'btn btn--default btn--icon-only btn--icon',
        {
          [this.baseClasses]: !this.isFullscreenIframe,
          'btn--md btn--negative modal__close-button modal__close-button--flush': this.isFullscreenIframe,
        },
      ];
    },
  },
};
</script>

<template>
  <button
    :class="classes"
    :aria-label="$t('Accessibility.modal.close')"
    data-cy="modal-close-button"
    @click="closeModal(modalId)"
  >
    <span class="sr-only">{{ $t('Accessibility.modal.close') }}</span>
    <span class="btn__icon">
      <phx-icon icon="cross-16" />
    </span>
  </button>
</template>
